
export function getSizeConfig(size: "xs" | "sm" | "default" | "lg") {
  const buttonSizes = {
    "xs": "h-7 w-auto min-w-8 px-1.5",
    "sm": "h-8 w-auto min-w-10 px-2",
    "default": "h-10 w-auto min-w-12 px-2.5",
    "lg": "h-12 w-auto min-w-14 px-3"
  };
  
  const iconSizes = {
    "xs": 14,
    "sm": 16,
    "default": 18,
    "lg": 22
  };
  
  return {
    buttonSize: buttonSizes[size],
    iconSize: iconSizes[size]
  };
}

